import { render, staticRenderFns } from "./GradeHistory.vue?vue&type=template&id=0c427c90&scoped=true&"
import script from "./GradeHistory.vue?vue&type=script&lang=js&"
export * from "./GradeHistory.vue?vue&type=script&lang=js&"
import style0 from "./GradeHistory.vue?vue&type=style&index=0&id=0c427c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c427c90",
  null
  
)

export default component.exports